module.exports = __webpack_public_path__ + "media/images/enabled_procedure_managements/area_examples_mobile-550020e00ff9c8ad9de34733bb17f76f.png";